<template>
    <v-flex pa-2 xs12>
        <Chatbot/>
    </v-flex>
</template>

<script>
    import Chatbot from "@/components/Chatbot/Chatbot";

    export default {
        name: "DialogsTesting",
        components: {
            Chatbot,
        },
        data() {
            return {
            };
        },
    };
</script>

<style lang="scss">

</style>

